import React from "react";
import Logo from "../../../assets/weblogo.png";
import Facebook from "../../../assets/facebook.png";
import Instagram from "../../../assets/instagram.png";
import Youtube from "../../../assets/youtube.png";
import LinkedIn from "../../../assets/linkedin.png";
import tiktok from "../../../assets/tiktok.png";

import { Link, useNavigate, useLocation } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer class="footer">
        <div class="container-2">
          <div>
            <div class="w-layout-grid footer-main-grid">
              <div class="footer-left-wrapper">
                <a
                  href=""
                  aria-current="page"
                  class="footer-logo-link w-nav-brand w--current"
                >
                  <img src={Logo} loading="lazy" width="200" />
                </a>
                <p class="subhead-main smaller">
                  Win Migration Group
                  <span class="gray-text-color footer">
                    <br />
                    Your trusted partner in education and migration services,
                    committed to helping clients achieve their dreams of
                    studying and living in Australia.{" "}
                  </span>
                </p>
                <div class="margin-25px add-line-divider">
                  <div>
                    <div class="footer-title">Sign up for our newsletter</div>
                    <div class="subscribe-form w-form">
                      <form
                        id="wf-form-Subscribe"
                        name="wf-form-Subscribe"
                        data-name="Subscribe"
                        method="get"
                        class="form-single"
                        data-wf-page-id="65790d6f586010464b337b4c"
                        data-wf-element-id="1e35ac5f-8e4d-cf7f-73fa-3d7463ee8b41"
                      >
                        <input
                          class="text-field-gray w-input"
                          maxlength="256"
                          name="Subscribe-2"
                          data-name="Subscribe 2"
                          placeholder="Enter your email..."
                          type="email"
                          id="Subscribe-2"
                          required=""
                        />
                        <div class="circle-button-wrapper">
                          <input
                            type="submit"
                            data-wait="Please wait..."
                            class="circle-button w-button"
                            value=""
                          />
                        </div>
                      </form>
                      <div class="success-message-2 w-form-done">
                        <div>Thank you! Your submission has been received!</div>
                      </div>
                      <div class="error-message w-form-fail">
                        <div>
                          Oops! Something went wrong while submitting the form.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-layout-grid footer-grid">
                <div className="footer-list">
                  <div className="footer-title">Navigation</div>
                  <Link to="/" className="footer-link-main w-inline-block">
                    <div>Home</div>
                  </Link>
                  <Link to="/About" className="footer-link-main w-inline-block">
                    <div>About</div>
                  </Link>
                  
                  <Link to="/Blog" className="footer-link-main w-inline-block">
                    <div>Blogs</div>
                  </Link>
                  <Link
                    to="/ContactUs"
                    className="footer-link-main w-inline-block"
                  >
                    <div>Contact Us</div>
                  </Link>
                </div>
                <div className="footer-list">
                  <div className="footer-title">Migration Services</div>
                  <div className="w-dyn-list">
                    <div role="list" className="w-dyn-items">
                      <div role="listitem" className="w-dyn-item">
                        <Link to="StudentVisas" className="footer-link-main">
                          <div>Student Visas</div>
                        </Link>
                      </div>
                      <div role="listitem" className="w-dyn-item">
                        <Link to="SkilledVisas" className="footer-link-main">
                          <div>Skilled Visas</div>
                        </Link>
                      </div>
                      <div role="listitem" className="w-dyn-item">
                        <Link to="EmployerVisas" className="footer-link-main">
                          <div>Employer-Sponsored Visas</div>
                        </Link>
                      </div>
                      <div role="listitem" className="w-dyn-item">
                        <Link to="FamilyVisas" className="footer-link-main">
                          <div>Family And Partner Visas</div>
                        </Link>
                      </div>
                      <div role="listitem" className="w-dyn-item">
                        <Link to="VisitorVisas" className="footer-link-main">
                          <div>Visitor Visas</div>
                        </Link>
                      </div>
                      <div role="listitem" className="w-dyn-item">
                        <Link
                          to="LabourAgreements"
                          className="footer-link-main"
                        >
                          <div>Labour Agreements</div>
                        </Link>
                      </div>
                      <div role="listitem" className="w-dyn-item">
                        <Link
                          to="SkillsAssessment"
                          className="footer-link-main"
                        >
                          <div>Skills Assessments</div>
                        </Link>
                      </div>
                      <div role="listitem" className="w-dyn-item">
                        <Link to="DAMA" className="footer-link-main">
                          <div>Designed Area Migration Agreement</div>
                        </Link>
                      </div>{" "}
                      <div role="listitem" className="w-dyn-item">
                        <Link to="ArtVisaAppeals" className="footer-link-main">
                          <div>ART Visa Appeals</div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="w-node-_60f520a7-147a-11a4-44da-c01ad3d35cbd-63ee8b33"
                  className="footer-list"
                >
                  <div className="footer-title">Legal</div>
                  <div>
                    <Link to="/PrivacyPolicy" className="footer-link-main">
                      <div className="text-block">Privacy Policy</div>
                    </Link>
                  </div>
                  <div>
                    <Link
                      to="/ConsultationTermsConditions"
                      className="footer-link-main"
                    >
                      <div className="text-block">
                        Consultation Terms And Conditions
                      </div>
                    </Link>
                  </div>
                  <div>
                    <Link to="/RefundPolicy" className="footer-link-main">
                      <div className="text-block">Refund Policy</div>
                    </Link>
                  </div>
                  <div>
                    <Link to="/TermsConditions" className="footer-link-main">
                      <div className="text-block">Terms and Conditions</div>
                    </Link>
                  </div>
                  <div>
                    <Link to="/TermsOfUse" className="footer-link-main">
                      <div className="text-block">Website Terms Of Use</div>
                    </Link>
                  </div>
                  <div>
                    <a
                      href="https://www.mara.gov.au/tools-for-agents-subsite/Files/code-of-conduct-march-2022-guidance.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="footer-link-main"
                    >
                      <div className="text-block">
                        Migration Code of conduct
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  id="w-node-_1e35ac5f-8e4d-cf7f-73fa-3d7463ee8b74-63ee8b33"
                  class="foorer-list"
                >
                  <div class="footer-title">Find us</div>
                  <div>
                    <div class="social-grid">
                      <a
                        href="https://www.instagram.com/winmigrationgroup/"
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={Instagram}
                          loading="lazy"
                          alt=""
                          class="social-icon"
                        />
                      </a>
                      <a
                        href="https://www.youtube.com/@winmigrationgroup"
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={Youtube}
                          loading="lazy"
                          alt=""
                          class="social-icon no-invert"
                        />
                      </a>
                      <a
                        href="https://www.linkedin.com/company/winmigrationgroup/"
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={LinkedIn}
                          loading="lazy"
                          alt=""
                          class="social-icon"
                        />
                      </a>
                      <a
                        href="https://www.facebook.com/winmigrationgroup/"
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={Facebook}
                          loading="lazy"
                          width="20"
                          alt=""
                          class="social-icon no-invert"
                        />
                      </a>
                      <a
                        href="https://www.tiktok.com/@winmigrationgroup1"
                        target="_blank"
                        class="social-link-main w-inline-block"
                      >
                        <img
                          src={tiktok}
                          loading="lazy"
                          width="20"
                          alt=""
                          class="social-icon no-invert"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
